export default {
  state: {
    loadingModal: false
  },
  mutations: {
    setLoadingModal(state, _loading) {
      state.loadingModal = _loading;
    }
  },
  getters: {
    getLoadingModal: state => state.loadingModal
  }
};
